import { ChannelItem } from 'src/app/models/channel_item';
import { IRepository } from 'src/app/repositories/interface.repository';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreResponseMessage } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { BaseRepository, OrderBy } from 'src/app/repositories/base.repository';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { Injectable } from "@angular/core";

export enum ChannelItemSortBy {
    Title,
    PublishDate,
    Tags
}

@Injectable()
export class ChannelItemRepository extends BaseRepository implements IRepository {
    constructor(public http: HttpClient, public functionService: FunctionsService, public clientConfig: ClientConfigService) {
        super(http, functionService, clientConfig, 'ChannelItem');
    }

    async getAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let channelItems: ChannelItem[] = [];
        return new CoreResponseMessage();
    }

    async getAllAsync(headers: HttpHeaders, pageIndex: number, pageSize: number, sortBy: ChannelItemSortBy, orderBy: OrderBy): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        return responseMessage;
    }

    async addAsync(headers: HttpHeaders, channelItems: ChannelItem[]): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        return responseMessage;
    }

    async updateAsync(headers: HttpHeaders, channelItem: ChannelItem): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        return responseMessage;
    }

    async removeAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        return responseMessage;
    }

    async addToFavoriteAsync(headers: HttpHeaders, channelItems: ChannelItem[]): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'AddToFavorite', JSON.stringify(channelItems), { headers }).toPromise().then(resp => {
            responseMessage = resp;
        }).catch(err => {
            responseMessage = err.error;
        });

        return responseMessage;
    }

    async getFavoriteItems(headers: HttpHeaders, pageIndex: number, pageSize: number, sortBy: ChannelItemSortBy, orderBy: OrderBy): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        const params = new HttpParams().set('pageIndex', pageIndex.toString())
                                       .set('pageSize', pageSize.toString())
                                       .set('sortBy', sortBy.toString())
                                       .set('orderBy', orderBy.toString());

        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'GetFavoriteItems', { headers, params }).toPromise().then(resp => {
            responseMessage = resp;
        }).catch(err => {
            responseMessage = err.error;
        });

        return responseMessage;
    }

    async removeFromFavoriteAsync(headers: HttpHeaders, channelItem: ChannelItem): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'RemoveFromFavorite', JSON.stringify(channelItem), { headers }).toPromise().then(resp => {
            responseMessage = resp;
        }).catch(err => {
            responseMessage = err.error;
        });

        return responseMessage;
    }

    async countFavoriteChannelItems(headers: HttpHeaders): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;

        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'CountFavoriteChannelItems', { headers }).toPromise().then(resp => {
            responseMessage = resp;
        }).catch(err => {
            responseMessage = err.error;
        });

        return responseMessage;
    }

    async getTodayFeedItemsAsync(pageIndex: number, pageSize: number, sortBy: ChannelItemSortBy, orderBy: OrderBy): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;
        const params = new HttpParams().set('pageIndex', pageIndex.toString())
                                       .set('pageSize', pageSize.toString())
                                       .set('sortBy', sortBy.toString())
                                       .set('orderBy', orderBy.toString());

        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'GetTodayFeedItems', { params }).toPromise().then(resp => {
            responseMessage = resp;
        }).catch(err => {
            responseMessage = err.error;
        });

        return responseMessage;
    }

    async refreshTodayFeedsAsync(headers: HttpHeaders): Promise<CoreResponseMessage> {
        let responseMessage: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'RefreshTodayFeeds', null, { headers }).toPromise().then(resp => {
            responseMessage = resp;
        }).catch(err => {
            responseMessage = err.error;
        })

        return responseMessage;
    }
}
